module.exports = __webpack_public_path__ + "img/News_item_16.e3a661f1.jpg";